import { API_URL, CapitalizeFirstWord } from "../../helpers/utils";
import axios from "axios";
import {
  catchHandler,
  dispatchError,
  dispatchLoading,
  dispatchToast,
  elseHandler,
} from "../../helpers/dispatch";
import {
  decryptByText,
  requestPayloadBodyFormate,
  responseDataFormate,
} from "../../helpers/bycrypt";
import { NavigateFunction } from "react-router-dom";
import axiosInstance from "../../helpers/axios";
import {
  formatAttributes,
  transformItemsByVariant,
} from "../Pages/Orders/orderTypes";
import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";
import { message } from "antd";
import AddDispatchTeamModal from "../Pages/Orders/Components/Modals/AddDispatchTeamModal";
import { deleteFromS3 } from "../../helpers/awsUpload";

// type DispatchAction = (action: { type: string; payload: { scope: string; status?: boolean | string | string[] } }) => void;

// type NavigateFunction = (path: string) => void;

const API_BASE_URL = `${API_URL}`;

let orderListCancelTokenSource: any;
let productionLogCancelTokenSource: any;
let ProductionJobDepartmentCancelTokenSource: any;
export const GetOrdersListAPI =
  (
    {
      page,
      limit,
      search,
      status,
      customer_id,
      is_active,
      start_date,
      end_date,
      sortBy,
      sortOrder,
      created_by,
    }: any,
    setHasMore: any,
  ) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getOrders", true);
    if (orderListCancelTokenSource) {
      orderListCancelTokenSource.cancel("Previous request cancelled");
    }
    orderListCancelTokenSource = axios.CancelToken.source();
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (status) params["status"] = status;
    if (customer_id) params["customer_id"] = customer_id;
    if (created_by) params["created_by"] = created_by;
    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;
    if (sortBy) params["sortBy"] = sortBy;
    if (sortOrder) params["sortOrder"] = sortOrder;
    if (is_active || is_active === 0) params["is_active"] = is_active;

    axiosInstance
      .get(`/orders`, {
        params: { ...params },
        cancelToken: orderListCancelTokenSource.token,
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          const newData = result?.data?.orders?.map((order: any) => ({
            ...order,
            order_created_by: order?.order_created_by
              ? {
                  ...order?.order_created_by,
                  email: decryptByText(order?.order_created_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(order?.order_created_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(order?.order_created_by?.last_name),
                  ),
                }
              : order?.created_by,
          }));
          dispatch({
            type: "GET_ORDERS_DATA",
            payload: {
              page: page,
              data: newData,
              count: result?.data?.pagination?.total,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.orders?.length == limit);
          }
          dispatchLoading(dispatch, "getOrders", false);
        } else elseHandler(dispatch, "getOrders", result);
        dispatchLoading(dispatch, "getOrders", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getOrders")(err);
        // navigate("/auth/login");
      });
  };

export const GetOrdersFilterListAPI =
  () => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getOrdersFilterData", true);
    let params: any = {};

    axiosInstance
      .get(`/orders/filter-data`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          const CreatedByData = result?.data?.created_by?.map((item: any) => ({
            ...item,
            email: decryptByText(item?.email),
            first_name: CapitalizeFirstWord(decryptByText(item?.first_name)),
            last_name: CapitalizeFirstWord(decryptByText(item?.last_name)),
            name: `${CapitalizeFirstWord(
              decryptByText(item?.first_name),
            )} ${CapitalizeFirstWord(decryptByText(item?.last_name))}`,
          }));

          dispatch({
            type: "GET_ORDERS_FILTER_DATA",
            payload: {
              CreatedByData: CreatedByData,
              CompanyData: result?.data?.customers,
            },
          });

          dispatchLoading(dispatch, "getOrdersFilterData", false);
        } else elseHandler(dispatch, "getOrdersFilterData", result);
        dispatchLoading(dispatch, "getOrdersFilterData", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getOrdersFilterData")(err);
        // navigate("/auth/login");
      });
  };

export const GetOrdersDetailsAPI =
  ({ order_id }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getOrderDetails", true);
    let params: any = {};
    // if (order_id) params["order_id"] = order_id;

    axiosInstance
      .get(`/orders/${order_id}`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          const newData = {
            ...result?.data,
            order_created_by: result?.data?.order_created_by
              ? {
                  ...result?.data?.order_created_by,
                  email: decryptByText(result?.data?.order_created_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.order_created_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.order_created_by?.last_name),
                  ),
                }
              : result?.data?.created_by,
          };
          dispatch({
            type: "GET_ORDERS_DETAILS",
            payload: newData,
          });
          dispatchLoading(dispatch, "getOrderDetails", false);
        } else elseHandler(dispatch, "getOrderDetails", result);
        dispatchLoading(dispatch, "getOrderDetails", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getOrderDetails")(err);
        // navigate("/auth/login");
      });
  };

export const Get2BSOrderBomAPI =
  ({ order_id }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getOrderBomAndWarnings", true);
    axiosInstance
      .get(`/2bs-order/${order_id}/bom`, {
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_ORDER_BOM_AND_WARNINGS_SUCCESS",
            payload: { ...result?.data, is_2bs_order: true },
          });
        }
        dispatchLoading(dispatch, "getOrderBomAndWarnings", false);
      })
      .catch((err) => {
        dispatchLoading(dispatch, "getOrderBomAndWarnings", false);
      });
  };

export const GetOrderBomAndWarningsAPI =
  ({ order_id, is_2bs_order }: any) =>
  async (dispatch: (action: any) => void) => {
    if (is_2bs_order) {
      return dispatch(Get2BSOrderBomAPI({ order_id }));
    }
    dispatchLoading(dispatch, "getOrderBomAndWarnings", true);
    axiosInstance
      .get(`/orders/${order_id}/bom-and-warnings`, {
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_ORDER_BOM_AND_WARNINGS_SUCCESS",
            // Do NOT spread order_id here — the route-param order_id is the MongoDB _id (ObjectId),
            // but orderDetails.order_id is the human-readable display number (e.g. "124").
            // Merging it would clobber the display ID in Redux state.
            payload: { ...result?.data },
          });
        }
        dispatchLoading(dispatch, "getOrderBomAndWarnings", false);
      })
      .catch((err) => {
        dispatchLoading(dispatch, "getOrderBomAndWarnings", false);
      });
  };

export const GetOrdersProductionPlanAPI =
  ({ order_id }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getProductionPlan", true);
    let params: any = {};
    // if (order_id) params["order_id"] = order_id;

    axiosInstance
      .get(`/orders/${order_id}/production-planning`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_ORDERS_PRODUCTION_PLAN",
            payload: result?.data,
          });
          dispatchLoading(dispatch, "getProductionPlan", false);
        } else elseHandler(dispatch, "getProductionPlan", result);
        dispatchLoading(dispatch, "getProductionPlan", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getProductionPlan")(err);
        // navigate("/auth/login");
      });
  };

export const DeleteOrderAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    const formatedData = requestPayloadBodyFormate(data);
    dispatchLoading(dispatch, "deleteOrder", true);
    axiosInstance
      .delete(`/orders/${data?.id}`, {
        data: formatedData,
        withCredentials: true,
      })
      .then(async (response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          const filesRemoved = result?.data?.filesRemoved || [];
          if (filesRemoved.length > 0) {
            for (const fileUrl of filesRemoved) {
              try {
                if (!fileUrl) continue;
                let key = fileUrl;
                if (
                  fileUrl.startsWith("http://") ||
                  fileUrl.startsWith("https://")
                ) {
                  const urlObj = new URL(fileUrl);
                  key = urlObj.pathname.substring(1);
                } else if (key.startsWith("/")) {
                  key = key.substring(1);
                }
                if (key) {
                  await deleteFromS3(key).catch(() => {});
                  const fileName = key.split("/").pop();
                  if (fileName) {
                    await deleteFromS3(`thumbnails/${fileName}`).catch(
                      () => {},
                    );
                  }
                }
              } catch (s3Err) {
                console.error("Failed to delete S3 object:", fileUrl, s3Err);
              }
            }
          }
          onClose();
          dispatch({
            type: "DELETE_ORDER",
            payload: data?.id,
          });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteOrder", undefined);
        } else elseHandler(dispatch, "deleteOrder", result);
        dispatchLoading(dispatch, "deleteOrder", false);
      })
      .catch(catchHandler(dispatch, "deleteOrder"));
  };

export const UpdateProductionDatesAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateProductionDate", true);
    const rawTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timezone =
      rawTimezone === "Asia/Calcutta"
        ? "Asia/Kolkata"
        : rawTimezone || "Asia/Kolkata";
    const formatedData = requestPayloadBodyFormate({ ...data, tz: timezone });
    axiosInstance
      .put(`/orders/${data?.order_id}/production-planning`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          const newData = {
            ...result?.data,
            production_start_date: result?.data?.production_start_date,
            production_completion_date:
              result?.data?.production_completion_date,
            delivery_date: result?.data?.delivery_date,
            installation_date: result?.data?.installation_date,
          };
          dispatch({
            type: "UPDATE_PRODUCTION_DATES_DATE",
            payload: newData,
          });
          if (onClose) {
            onClose();
          }
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateProductionDate", undefined);
        } else elseHandler(dispatch, "updateProductionDate", result);
        dispatchLoading(dispatch, "updateProductionDate", false);
      })
      .catch(catchHandler(dispatch, "updateProductionDate"));
  };

export const SpliteProductAPI =
  (order_id: any, data: any, onClose?: any, onConflict?: any, onError?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "splitProduct", true);
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .put(
        `/orders/${order_id}/production-planning/splits?tz=${timezone}`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (!result?.success && result?.data?.conflicts?.length > 0) {
          if (onConflict) {
            onConflict(result?.data?.conflicts[0]);
            dispatchError(dispatch, "splitProduct", undefined);
          }
        } else if (result?.success) {
          dispatch({
            type: "SPLIT_PRODUCT_SUCCESS",
            payload: result?.data,
          });
          if (onClose) {
            onClose(result?.data);
          }
          // dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "splitProduct", undefined);
        } else {
          if (onError) {
            onError();
          }
          elseHandler(dispatch, "splitProduct", result);
        }
        dispatchLoading(dispatch, "splitProduct", false);
      })
      .catch((err) => {
        if (onError) {
          onError(err);
        }
        catchHandler(dispatch, "splitProduct")(err);
      });
  };

export const PrefillProductionPlanningAPI =
  (order_id: any, onSuccess?: any, onError?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "prefillProductionPlanning", true);
    axiosInstance
      .put(
        `/orders/${order_id}/production-planning/prefill`,
        {},
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Data prefilled successfully",
          );
          if (onSuccess) {
            onSuccess(result?.data);
          }
          dispatchLoading(dispatch, "prefillProductionPlanning", false);
        } else {
          elseHandler(dispatch, "prefillProductionPlanning", result);
          if (onError) onError();
        }
      })
      .catch((err) => {
        catchHandler(dispatch, "prefillProductionPlanning")(err);
        if (onError) onError();
      });
  };

export const ChangeOrderStatusAPI =
  (order_id: any, data: any, onClose?: any, onErorr?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "changeOrderStatus", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .put(`/orders/${order_id}/status`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "CHANGE_ORDER_STATUS",
            payload: {
              status: data?.order_status,
              dispatched_details: result?.data?.dispatched_details,
            },
          });
          if (onClose) {
            onClose(result?.data?.customized_data);
          }
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "changeOrderStatus", undefined);
        } else {
          // if (result?.message == "INSUFFICIENT_LEAN_PRODUCT_STOCK") {
          //   message.error(result?.error);
          // } else {
          if (onErorr) {
            onErorr(result?.data);
          }
          if (!result?.data?.flag) {
            elseHandler(dispatch, "changeOrderStatus", result);
          }
          // }
        }
        dispatchLoading(dispatch, "changeOrderStatus", false);
      })
      .catch((error: any) => {
        if (error?.response?.status === 411) {
          let result = responseDataFormate(error.response.data);
          if (onErorr) {
            // Match the expected structure: { flag: string, data: any }
            onErorr({
              flag:
                result?.message === "VARIABLE_CONFIRMATION_REQUIRED"
                  ? "VARIABLE_CONFIRMATION_REQUIRED"
                  : "DROP_TBC_ERROR",
              data: result?.data,
            });
          }
          dispatchLoading(dispatch, "changeOrderStatus", false);
        } else {
          catchHandler(dispatch, "changeOrderStatus")(error);
        }
      });
  };

export const GetOrdersProductionPlanCalenderDataAPI =
  ({ start_at_start, end_at_end, order_id }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getProductionPlanCalender", true);
    let params: any = {};
    if (start_at_start) params["start_at_start"] = start_at_start;
    if (end_at_end) params["end_at_end"] = end_at_end;
    if (order_id) params["order_id"] = order_id;

    axiosInstance
      .get(`/orders/production-planning/chart`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          const ordersData =
            result?.data?.data?.length > 0
              ? result?.data?.data?.map((order: any) => {
                  const spliteData: any[] = [];

                  order?.items?.forEach((item: any) => {
                    item?.splits?.forEach((split: any) => {
                      const variant = item?.product?.variants?.find(
                        (v: any) => v?.variant_id === split?.variant_id,
                      );
                      spliteData.push({
                        _id: split?._id,
                        item_id: item?._id,
                        order_id: order?.order_id?._id,
                        order_data: order?.order_id,
                        display_order_id: order?.order_id?.order_id,
                        product_name: item?.name,
                        item_type: item?.item_type,
                        product_id: item?.product?.product_id,
                        specifications: item?.product?.description,
                        labelInQuotation: item?.labelInQuotation,
                        qty: split?.qty,
                        manufactured: split?.manufactured_qty,
                        imageUrl: item?.product?.pre_galvanised_image,
                        startDate: split?.start_at,
                        endDate: split?.end_at,
                        orignal_start_date: split?.start_at,
                        orignal_end_date: split?.end_at,
                        department_id: split?.department_id,
                        variant_id: split?.variant_id,
                        machine_id: split?.machine_id,
                        employee_ids: split?.employee_ids,
                        pending_qty: split?.pending_qty,
                        status: split?.status,
                        production_completion_date:
                          order?.production_completion_date,
                      });
                    });
                  });
                  const client_name =
                    CapitalizeFirstWord(
                      order?.order_id?.customer_snapshot?.first_name,
                    ) +
                    " " +
                    CapitalizeFirstWord(
                      order?.order_id?.customer_snapshot?.last_name,
                    );
                  return {
                    _id: order?.order_id?._id,
                    order: order?.order_id?.order_id,
                    items: spliteData,
                    company: order?.order_id?.customer_snapshot?.company_name,
                    client_name: client_name,
                  };
                })
              : [];
          dispatch({
            type: "GET_ORDERS_PRODUCTION_PLAN_CALENDER_DATA",
            payload: ordersData,
          });
          setTimeout(() => {
            dispatchLoading(dispatch, "getProductionPlanCalender", false);
          }, 300);
        } else elseHandler(dispatch, "getProductionPlanCalender", result);
        dispatchLoading(dispatch, "getProductionPlanCalender", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getProductionPlanCalender")(err);
        // navigate("/auth/login");
      });
  };

export const UpdateDataInCalenderAPI =
  (order_id: any, data: any, onClose?: any, onConflict?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateItemDataCalender", true);
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .put(
        `/orders/${order_id}/production-planning/splits?tz=${timezone}`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (!result?.success && result?.data?.conflicts?.length > 0) {
          if (onConflict) {
            onConflict(result?.data?.conflicts[0]);
            dispatchError(dispatch, "updateItemDataCalender", undefined);
          }
        } else if (result?.success) {
          if (onClose) {
            onClose(result?.data);
          }
          // dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateItemDataCalender", undefined);
        } else elseHandler(dispatch, "updateItemDataCalender", result);
        dispatchLoading(dispatch, "updateItemDataCalender", false);
      })
      .catch(catchHandler(dispatch, "updateItemDataCalender"));
  };

export const UpdateOrderIdAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateOrderId", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .put(`/orders/${data?.id}/order-id`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "UPDATE_ORDER_ID",
            payload: result?.data?.order_id,
          });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateOrderId", undefined);
          onClose();
        } else elseHandler(dispatch, "updateOrderId", result);
        dispatchLoading(dispatch, "updateOrderId", false);
      })
      .catch(catchHandler(dispatch, "updateOrderId"));
  };

export const SendClientDispatchMailAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "sendDispatchMail", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .put(`/orders/${data?.order_id}/send-confirmation-email`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "SEND_CLIENT_DISPATCH_MAIL",
          });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "sendDispatchMail", undefined);
          onClose();
        } else elseHandler(dispatch, "sendDispatchMail", result);
        dispatchLoading(dispatch, "sendDispatchMail", false);
      })
      .catch(catchHandler(dispatch, "sendDispatchMail"));
  };

export const GetOrdersDetailsForClientAPI =
  ({ order_id }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getOrderDetailsForClient", true);
    let params: any = {};
    // if (order_id) params["order_id"] = order_id;

    axiosInstance
      .get(`/orders/${order_id}/client-review`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          const newData = {
            ...result?.data,
            order_created_by: result?.data?.order_created_by
              ? {
                  ...result?.data?.order_created_by,
                  email: decryptByText(result?.data?.order_created_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.order_created_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.order_created_by?.last_name),
                  ),
                }
              : result?.data?.created_by,
            customer_id: result?.data?.customer_id
              ? {
                  ...result?.data?.customer_id,
                  email: decryptByText(result?.data?.customer_id?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.customer_id?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.customer_id?.last_name),
                  ),
                }
              : result?.data?.created_by,
          };
          dispatch({
            type: "GET_ORDERS_DETAILS_FOR_CLIENT",
            payload: newData,
          });
          dispatchLoading(dispatch, "getOrderDetailsForClient", false);
        } else elseHandler(dispatch, "getOrderDetailsForClient", result);
        dispatchLoading(dispatch, "getOrderDetailsForClient", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getOrderDetailsForClient")(err);
        // navigate("/auth/login");
      });
  };

export const InstallationClientSignUploadAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "clientSignUpload", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .put(
        `/orders/${data?.order_id}/sign-installation-confirmation`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "clientSignUpload", undefined);
        } else elseHandler(dispatch, "clientSignUpload", result);
        dispatchLoading(dispatch, "clientSignUpload", false);
      })
      .catch(catchHandler(dispatch, "clientSignUpload"));
  };

export const GetOrdersDispatchPlanningDetailsPI =
  ({ order_id }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getDispatchPlaningDetails", true);
    let params: any = {};
    // if (order_id) params["order_id"] = order_id;

    axiosInstance
      .get(`/orders/${order_id}/dispatch-planning`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_ORDERS_DISPATCH_PLANNING_DETAILS",
            payload: result?.data?.data,
          });
          dispatchLoading(dispatch, "getDispatchPlaningDetails", false);
        } else elseHandler(dispatch, "getDispatchPlaningDetails", result);
        dispatchLoading(dispatch, "getDispatchPlaningDetails", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getDispatchPlaningDetails")(err);
        // navigate("/auth/login");
      });
  };

export const GetMezzanineOrdersDispatchPlanningDetailsAPI =
  ({ order_id }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getMezzanineDispatchPlaningDetails", true);
    axiosInstance
      .get(`/mezzanine-storage-type/orders/${order_id}/dispatch-planning`, {
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_MEZZANINE_ORDERS_DISPATCH_PLANNING_DETAILS",
            payload: result?.data?.data,
          });
          dispatchLoading(
            dispatch,
            "getMezzanineDispatchPlaningDetails",
            false,
          );
        } else
          elseHandler(dispatch, "getMezzanineDispatchPlaningDetails", result);
        dispatchLoading(dispatch, "getMezzanineDispatchPlaningDetails", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getMezzanineDispatchPlaningDetails")(err);
      });
  };

export const UpdateMezzanineOrderDispatchPlaningLoadAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addDispatchLoads", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .put(
        `/mezzanine-storage-type/orders/${data?.order_id}/dispatch-planning/loads`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch(
            GetMezzanineOrdersDispatchPlanningDetailsAPI({
              order_id: data?.order_id,
            }),
          );
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "addDispatchLoads", undefined);
          onClose();
        } else elseHandler(dispatch, "addDispatchLoads", result);
        dispatchLoading(dispatch, "addDispatchLoads", false);
      })
      .catch(catchHandler(dispatch, "addDispatchLoads"));
  };

export const UpdateMezzanineOrderDispatchStatusAPI =
  (data: any, onClose?: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateDispatchStatus", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .patch(
        `/mezzanine-storage-type/orders/${data?.order_id}/dispatch-planning/${data?.load_id}/status`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch(
            GetMezzanineOrdersDispatchPlanningDetailsAPI({
              order_id: data?.order_id,
            }),
          );
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateDispatchStatus", undefined);
          if (onClose) onClose();
        } else elseHandler(dispatch, "updateDispatchStatus", result);
        dispatchLoading(dispatch, "updateDispatchStatus", false);
      })
      .catch(catchHandler(dispatch, "updateDispatchStatus"));
  };

export const UpdateMezzanineOrderDispatchDetailsAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateDispatchDetails", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .patch(
        `/mezzanine-storage-type/orders/${data?.order_id}/dispatch-planning/${data?.load_id}/dispatched-details`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch(
            GetMezzanineOrdersDispatchPlanningDetailsAPI({
              order_id: data?.order_id,
            }),
          );
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateDispatchDetails", undefined);
          onClose();
        } else elseHandler(dispatch, "updateDispatchDetails", result);
        dispatchLoading(dispatch, "updateDispatchDetails", false);
      })
      .catch(catchHandler(dispatch, "updateDispatchDetails"));
  };

export const AddMezzanineOrderDispatchTeamAPI =
  (data: any, onClose?: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addDispatchTeam", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .patch(
        `/mezzanine-storage-type/orders/${data?.order_id}/dispatch-planning/${data?.load_id}/employees`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch(
            GetMezzanineOrdersDispatchPlanningDetailsAPI({
              order_id: data?.order_id,
            }),
          );
          if (onClose) onClose(result?.data);
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "addDispatchTeam", undefined);
        } else elseHandler(dispatch, "addDispatchTeam", result);
        dispatchLoading(dispatch, "addDispatchTeam", false);
      })
      .catch(catchHandler(dispatch, "addDispatchTeam"));
  };

export const UpdateOrderDispatchPlaningLoadAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addDispatchLoads", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .put(`/orders/${data?.order_id}/dispatch-planning/loads`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch(
            GetOrdersDispatchPlanningDetailsPI({ order_id: data?.order_id }),
          );
          // dispatch({
          //   type: "UPDATE_ORDER_ID",
          //   payload: result?.data?.order_id,
          // });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "addDispatchLoads", undefined);
          onClose();
        } else elseHandler(dispatch, "addDispatchLoads", result);
        dispatchLoading(dispatch, "addDispatchLoads", false);
      })
      .catch(catchHandler(dispatch, "addDispatchLoads"));
  };

export const UpdateOrderDispatchStatusAPI =
  (data: any, onClose?: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateDispatchStatus", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .patch(
        `/orders/${data?.order_id}/dispatch-planning/${data?.load_id}/status`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "UPDTAE_DISPATCH_DATA",
            payload: {
              ...data,
              data: result?.data,
            },
          });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateDispatchStatus", undefined);
          if (onClose) onClose();
        } else elseHandler(dispatch, "updateDispatchStatus", result);
        dispatchLoading(dispatch, "updateDispatchStatus", false);
      })
      .catch(catchHandler(dispatch, "updateDispatchStatus"));
  };

export const UpdateOrderDispatchDetailsAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateDispatchDetails", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .patch(
        `/orders/${data?.order_id}/dispatch-planning/${data?.load_id}/dispatched-details`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch(
            GetOrdersDispatchPlanningDetailsPI({ order_id: data?.order_id }),
          );
          // dispatch({
          //   type: "UPDATE_ORDER_ID",
          //   payload: result?.data?.order_id,
          // });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateDispatchDetails", undefined);
          onClose();
        } else elseHandler(dispatch, "updateDispatchDetails", result);
        dispatchLoading(dispatch, "updateDispatchDetails", false);
      })
      .catch(catchHandler(dispatch, "updateDispatchDetails"));
  };

export const UpdateOrderDispatchPlanningManageAPI =
  (data: any, onClose?: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateDispatchPlanningManage", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .patch(
        `/orders/${data?.order_id}/dispatch-planning/manage`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch(
            GetOrdersDispatchPlanningDetailsPI({ order_id: data?.order_id }),
          );
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateDispatchPlanningManage", undefined);
          if (onClose) onClose();
        } else elseHandler(dispatch, "updateDispatchPlanningManage", result);
        dispatchLoading(dispatch, "updateDispatchPlanningManage", false);
      })
      .catch(catchHandler(dispatch, "updateDispatchPlanningManage"));
  };

export const UpdateOrderDispatchActualManageAPI =
  (data: any, onClose?: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateDispatchActualManage", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .patch(
        `/orders/${data?.order_id}/dispatch-planning/dispatched/manage`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch(
            GetOrdersDispatchPlanningDetailsPI({ order_id: data?.order_id }),
          );
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateDispatchActualManage", undefined);
          if (onClose) onClose();
        } else elseHandler(dispatch, "updateDispatchActualManage", result);
        dispatchLoading(dispatch, "updateDispatchActualManage", false);
      })
      .catch(catchHandler(dispatch, "updateDispatchActualManage"));
  };

export const UpdateOrderDispatchFilesAPI =
  (data: any, onClose?: any, isDelete?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateDispatchFiles", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .patch(
        `/orders/${data?.order_id}/dispatch-planning/${data?.load_id}/files`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_ORDERS_DISPATCH_PLANNING_DETAILS",
            payload: result?.data,
          });
          // dispatch(
          //   GetOrdersDispatchPlanningDetailsPI({ order_id: data?.order_id }),
          // );
          if (isDelete) {
            dispatchToast(
              dispatch,
              "success",
              "Dispatch file deleted successfully.",
            );
          } else {
            dispatchToast(dispatch, "success", result?.message);
          }

          dispatchError(dispatch, "updateDispatchFiles", undefined);
          if (onClose) onClose();
        } else elseHandler(dispatch, "updateDispatchFiles", result);
        dispatchLoading(dispatch, "updateDispatchFiles", false);
      })
      .catch(catchHandler(dispatch, "updateDispatchFiles"));
  };

export const generatePaymentRecieptAPI =
  ({ payload, onSuccess, onError }: any) =>
  async (dispatch: any) => {
    const rawTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timezone =
      rawTimezone === "Asia/Calcutta"
        ? "Asia/Kolkata"
        : rawTimezone || "Asia/Kolkata";
    try {
      const response = await axiosInstance.post(
        `/orders/download-payment-receipt`,
        { ...payload, tz: timezone },
        {
          responseType: "blob",
        },
      );

      let fileName = "Quotation.pdf";

      const contentDisposition = response.headers["content-disposition"];

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (fileNameMatch && fileNameMatch.length === 2) {
          fileName = fileNameMatch[1];
        }
      }

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      if (Capacitor.isNativePlatform()) {
        const reader = new FileReader();

        const blobToBase64 = (blob: Blob) =>
          new Promise((resolve, reject) => {
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });

        try {
          const result: any = await blobToBase64(blob);
          const base64Data = result?.split(",")[1];

          const uniqueFileName = `${Date.now()}_${fileName}`;

          const savedFile = await Filesystem.writeFile({
            path: uniqueFileName,
            data: base64Data,
            directory: Directory.Cache,
          });

          await Share.share({
            url: savedFile.uri,
          });

          onSuccess?.();
        } catch (err) {
          console.error("Native Share Error:", err);
          onError?.();
        }
      } else {
        // 3. Create a hidden link element to trigger the download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // 4. Set the dynamic filename
        link.setAttribute("download", fileName);

        // 5. Trigger click and cleanup
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(url);

        onSuccess?.();
        message.success("Payment Receipt downloaded successfully!");
      }
    } catch (error: any) {
      console.error("PDF Generation error:", error);
      onError?.();

      // Helper to read the error message from a Blob (since responseType is blob)
      if (error.response && error.response.data instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const errorObj = JSON.parse(reader.result as string);
            message.error(errorObj.message || "Failed to generate PDF");
          } catch (e) {
            message.error("Failed to generate PDF");
          }
        };
        reader.readAsText(error.response.data);
      } else {
        message.error("Failed to generate PDF");
      }
    }
  };

export const generateJobDepartmentAPI =
  ({ payload, onSuccess, onError }: any) =>
  async (dispatch: any) => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const { order_id, ...queryParams } = payload || {};
      const response = await axiosInstance.get(
        `/orders/download-department-jobs/${order_id}`,
        {
          params: queryParams,
          responseType: "blob",
        },
      );

      const contentType = response.headers["content-type"];
      let fileName =
        typeof contentType === "string" && contentType.includes("zip")
          ? "Job_Department_Data.zip"
          : "Job_Department_Data.pdf";

      const contentDisposition = response.headers["content-disposition"];

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (fileNameMatch && fileNameMatch.length === 2) {
          fileName = fileNameMatch[1];
        }
      }

      const blob = new Blob([response.data], {
        type: typeof contentType === "string" ? contentType : "application/pdf",
      });

      if (Capacitor.isNativePlatform()) {
        const reader = new FileReader();

        const blobToBase64 = (blob: Blob) =>
          new Promise((resolve, reject) => {
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });

        try {
          const result: any = await blobToBase64(blob);
          const base64Data = result?.split(",")[1];

          const uniqueFileName = `${Date.now()}_${fileName}`;

          const savedFile = await Filesystem.writeFile({
            path: uniqueFileName,
            data: base64Data,
            directory: Directory.Cache,
          });

          await Share.share({
            url: savedFile.uri,
          });

          onSuccess?.();
        } catch (err) {
          console.error("Native Share Error:", err);
          onError?.();
        }
      } else {
        // 3. Create a hidden link element to trigger the download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // 4. Set the dynamic filename
        link.setAttribute("download", fileName);

        // 5. Trigger click and cleanup
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(url);

        onSuccess?.();
        const actionLabels: Record<string, string> = {
          production_sheet: "Production Sheet per Department",
          master_production_sheet: "Master Production Sheet",
          purchasing_checklist: "Purchasing Checklist",
        };
        const successLabel = payload?.action
          ? actionLabels[payload.action] || "Sheet"
          : "All jobs pdf";
        message.success(`${successLabel} downloaded successfully!`);
      }
    } catch (error: any) {
      console.error("PDF Generation error:", error);
      onError?.();

      // Helper to read the error message from a Blob (since responseType is blob)
      if (error.response && error.response.data instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const errorObj = JSON.parse(reader.result as string);
            message.error(errorObj.message || "Failed to generate PDF");
          } catch (e) {
            message.error("Failed to generate PDF");
          }
        };
        reader.readAsText(error.response.data);
      } else {
        message.error("Failed to generate PDF");
      }
    }
  };

export const AddOrderDispatchTeamAPI =
  (data: any, onClose?: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addDispatchTeam", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .patch(
        `/orders/${data?.order_id}/dispatch-planning/${data?.load_id}/employees`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "DISPATCH_EMPLOYEE_ADD",
            payload: {
              data: result?.data,
              load_id: data?.load_id,
              for_all_loads: data?.for_all_loads,
            },
          });
          if (onClose) onClose(result?.data);
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "addDispatchTeam", undefined);
        } else elseHandler(dispatch, "addDispatchTeam", result);
        dispatchLoading(dispatch, "addDispatchTeam", false);
      })
      .catch(catchHandler(dispatch, "addDispatchTeam"));
  };

export const GetManufacturingProductsListAPI =
  (
    {
      today_date,
      splits_id,
      _id,
      limit,
      page,
      department_id,
      machine_id,
      employee_id,
      sortBy,
    }: any,
    single?: any,
    setHasMore?: any,
  ) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getManufacturingProducts", true);
    let params: any = {};
    if (limit) params["limit"] = limit;
    if (page) params["page"] = page;
    if (today_date) params["today_date"] = today_date;
    if (splits_id) params["splits_id"] = splits_id;
    if (_id) params["_id"] = _id;
    if (department_id) params["department_id"] = department_id;
    if (machine_id) params["machine_id"] = machine_id;
    if (employee_id) params["employee_id"] = employee_id;
    if (sortBy) params["sortBy"] = sortBy;

    axiosInstance
      .get(`/orders/manufacturing/products`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          if (single) {
            dispatch({
              type: "GET_MANUFACTURING_PRODUCTS_DETAILS",
              payload: result?.data?.data[0],
            });
          } else {
            dispatch({
              type: "GET_MANUFACTURING_PRODUCTS_LIST",
              payload: { data: result?.data?.data, page: page || 1 },
            });
          }
          if (setHasMore) {
            setHasMore(result?.data?.data?.length == limit);
          }
          dispatchLoading(dispatch, "getManufacturingProducts", false);
        } else elseHandler(dispatch, "getManufacturingProducts", result);
        dispatchLoading(dispatch, "getManufacturingProducts", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getManufacturingProducts")(err);
        // navigate("/auth/login");
      });
  };

export const AddOrderProductionLogAPI =
  (payload: any, callback?: (success?: boolean) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addOrderProductionLog", true);
    axiosInstance
      .post(`/orders/manufacturing/add-production-logs`, payload)
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "ADD_ORDER_PRODUCTION_LOG",
            payload: {
              ...result?.data,
              production_planning_id: payload?.production_planning_id,
              splits_id: payload?.splits_id,
              department_id: payload?.department_id,
              status: payload?.status,
            },
          });
          if (callback) callback(true);
          dispatchLoading(dispatch, "addOrderProductionLog", false);
        } else {
          elseHandler(dispatch, "addOrderProductionLog", result);
          if (callback) callback(false);
        }
        dispatchLoading(dispatch, "addOrderProductionLog", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "addOrderProductionLog")(err);
        if (callback) callback(false);
        dispatchLoading(dispatch, "addOrderProductionLog", false);
      });
  };

export const GetOrderProductionLogsAPI =
  ({ page, limit, ...params }: any, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getOrderProductionLogs", true);
    if (productionLogCancelTokenSource) {
      productionLogCancelTokenSource.cancel("Previous request cancelled");
    }
    productionLogCancelTokenSource = axios.CancelToken.source();
    axiosInstance
      .get(`/orders/manufacturing/production-logs`, {
        params: { page, limit, ...params },
        cancelToken: productionLogCancelTokenSource.token,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          if (setHasMore) {
            setHasMore(result?.data?.data?.length === limit);
          }
          dispatch({
            type: "GET_MANUFACTURING_PRODUCTION_LOGS",
            payload: {
              data: result?.data?.data,
              page: page,
            },
          });
          dispatchLoading(dispatch, "getOrderProductionLogs", false);
        } else elseHandler(dispatch, "getOrderProductionLogs", result);
        dispatchLoading(dispatch, "getOrderProductionLogs", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getOrderProductionLogs")(err);
        dispatchLoading(dispatch, "getOrderProductionLogs", false);
      });
  };

export const EditOrderProductionLogAPI =
  (payload: any, callback?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "editOrderProductionLog", true);
    axiosInstance
      .put(`/orders/manufacturing/edit-production-logs`, payload)
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "EDIT_ORDER_PRODUCTION_LOG",
            payload: { ...result?.data, ...payload },
          });
          if (callback) callback();
          dispatchLoading(dispatch, "editOrderProductionLog", false);
        } else elseHandler(dispatch, "editOrderProductionLog", result);
        dispatchLoading(dispatch, "editOrderProductionLog", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "editOrderProductionLog")(err);
        dispatchLoading(dispatch, "editOrderProductionLog", false);
      });
  };

export const DeleteOrderProductionLogAPI =
  (data: any, callback?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "deleteOrderProductionLog", true);
    axiosInstance
      .delete(`/orders/manufacturing/delete-production-logs/${data?.log_id}`)
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "DELETE_ORDER_PRODUCTION_LOG",
            payload: {
              log_id: data?.log_id,
              department_id: data?.department_id,
              productionStatus: result?.data?.productionStatus,
            },
          });
          if (callback) callback();
          dispatchLoading(dispatch, "deleteOrderProductionLog", false);
        } else elseHandler(dispatch, "deleteOrderProductionLog", result);
        dispatchLoading(dispatch, "deleteOrderProductionLog", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "deleteOrderProductionLog")(err);
        dispatchLoading(dispatch, "deleteOrderProductionLog", false);
      });
  };

export const getProductinJobsUniqueDepartment =
  () => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getProductinJobsUniqueDepartment", true);
    axiosInstance
      .get(`/orders/manufacturing/unique-department`)
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_JOB_PRODUCTION_UNIQUE_DEPARTMENT",
            payload: result?.data,
          });
          dispatchLoading(dispatch, "getProductinJobsUniqueDepartment", false);
        } else
          elseHandler(dispatch, "getProductinJobsUniqueDepartment", result);
        dispatchLoading(dispatch, "getProductinJobsUniqueDepartment", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getProductinJobsUniqueDepartment")(err);
        dispatchLoading(dispatch, "getProductinJobsUniqueDepartment", false);
      });
  };
export const getProductinUniqueDepartment =
  ({ order_id, categories_snapshot_id }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getOrderProductionDepartment", true);
    let params: any = {};
    if (order_id) params["order_id"] = order_id;
    if (categories_snapshot_id)
      params["categories_snapshot_id"] = categories_snapshot_id;

    axiosInstance
      .get(`/orders/production-planning/unique-departments`, {
        params: params,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_ORDER_PRODUCTION_DEPARTMENT",
            payload: result?.data,
          });
          dispatchLoading(dispatch, "getOrderProductionDepartment", false);
        } else elseHandler(dispatch, "getOrderProductionDepartment", result);
        dispatchLoading(dispatch, "getOrderProductionDepartment", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getOrderProductionDepartment")(err);
        dispatchLoading(dispatch, "getOrderProductionDepartment", false);
      });
  };

export const getProductionJobsData =
  ({ order_id, department_id, categories_snapshot_id }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getProductionJobsData", true);
    let params: any = {};
    if (ProductionJobDepartmentCancelTokenSource) {
      ProductionJobDepartmentCancelTokenSource.cancel(
        "Previous request cancelled",
      );
    }
    ProductionJobDepartmentCancelTokenSource = axios.CancelToken.source();

    if (department_id) params["department_id"] = department_id;
    if (categories_snapshot_id)
      params["categories_snapshot_id"] = categories_snapshot_id;

    axiosInstance
      .get(`/orders/${order_id}/production-job-data`, {
        params: params,
        cancelToken: ProductionJobDepartmentCancelTokenSource.token,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_PRODUCTION_JOBS_DATA",
            payload: result?.data?.customized_data,
          });
          dispatchLoading(dispatch, "getProductionJobsData", false);
        } else elseHandler(dispatch, "getProductionJobsData", result);
        dispatchLoading(dispatch, "getProductionJobsData", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getProductionJobsData")(err);
        dispatchLoading(dispatch, "getProductionJobsData", false);
      });
  };

export const generateJobLebelesAPI =
  ({ payload, onSuccess, onError }: any) =>
  async (dispatch: any) => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const response = await axiosInstance.get(
        `/orders/download-department-jobs/dymo/job-labels`,
        {
          responseType: "blob",
        },
      );

      let fileName = "Job Labels Data.pdf";

      const contentDisposition = response.headers["content-disposition"];

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (fileNameMatch && fileNameMatch.length === 2) {
          fileName = fileNameMatch[1];
        }
      }

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      if (Capacitor.isNativePlatform()) {
        const reader = new FileReader();

        const blobToBase64 = (blob: Blob) =>
          new Promise((resolve, reject) => {
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });

        try {
          const result: any = await blobToBase64(blob);
          const base64Data = result?.split(",")[1];

          const uniqueFileName = `${Date.now()}_${fileName}`;

          const savedFile = await Filesystem.writeFile({
            path: uniqueFileName,
            data: base64Data,
            directory: Directory.Cache,
          });

          await Share.share({
            url: savedFile.uri,
          });

          onSuccess?.();
        } catch (err) {
          console.error("Native Share Error:", err);
          onError?.();
        }
      } else {
        // 3. Create a hidden link element to trigger the download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // 4. Set the dynamic filename
        link.setAttribute("download", fileName);

        // 5. Trigger click and cleanup
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(url);

        onSuccess?.();
        message.success("Job Labels downloaded successfully!");
      }
    } catch (error: any) {
      console.error("PDF Generation error:", error);
      onError?.();

      // Helper to read the error message from a Blob (since responseType is blob)
      if (error.response && error.response.data instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const errorObj = JSON.parse(reader.result as string);
            message.error(errorObj.message || "Failed to generate PDF");
          } catch (e) {
            message.error("Failed to generate PDF");
          }
        };
        reader.readAsText(error.response.data);
      } else {
        message.error("Failed to generate PDF");
      }
    }
  };

export const AddLabelPrintLogLogAPI =
  (payload: any, callback?: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addLabelPrintLog", true);
    axiosInstance
      .post(`/orders/production-job/label/mark-label-printed`, payload)
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch(getJobsLabelsData({ order_id: payload?.order_id }));
          if (callback) callback(result?.data);
          dispatchLoading(dispatch, "addLabelPrintLog", false);
        } else elseHandler(dispatch, "addLabelPrintLog", result);
        dispatchLoading(dispatch, "addLabelPrintLog", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "addLabelPrintLog")(err);
        dispatchLoading(dispatch, "addLabelPrintLog", false);
      });
  };

export const getJobsLabelsData =
  ({ order_id }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getJobsLabelsData", true);
    let params: any = {};

    if (order_id) params["order_id"] = order_id;

    axiosInstance
      .get(`/orders/production-job/label/printed-labels`, {
        params: params,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_PRINTED_JOB_LABEL_DATA",
            payload: result?.data,
          });
          dispatchLoading(dispatch, "getJobsLabelsData", false);
        } else elseHandler(dispatch, "getJobsLabelsData", result);
        dispatchLoading(dispatch, "getJobsLabelsData", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getJobsLabelsData")(err);
        dispatchLoading(dispatch, "getJobsLabelsData", false);
      });
  };

export const RemovePritedLabelHistory =
  ({ printed_label_id, history_id }: any, callback?: () => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "removePrintedDataHistory", true);
    axiosInstance
      .delete(`/orders/production-job/label/printed-labels/${printed_label_id}`)
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          // dispatch({
          //   type: "DELETE_ORDER_PRODUCTION_LOG",
          //   payload: {
          //     log_id: data?.log_id,
          //     department_id: data?.department_id,
          //     productionStatus: result?.data?.productionStatus,
          //   },
          // });
          if (callback) callback();
          dispatchLoading(dispatch, "removePrintedDataHistory", false);
        } else elseHandler(dispatch, "removePrintedDataHistory", result);
        dispatchLoading(dispatch, "removePrintedDataHistory", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "removePrintedDataHistory")(err);
        dispatchLoading(dispatch, "removePrintedDataHistory", false);
      });
  };

export const generateInstallationCertificateAPI =
  ({ payload, onSuccess, onError }: any) =>
  async (dispatch: any) => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const response = await axiosInstance.get(
        `/orders/download-installation-certificate/${payload?.order_id}`,
        {
          params: payload,
          responseType: "blob",
        },
      );

      let fileName = "Installation_Certificate.pdf";

      const contentDisposition = response.headers["content-disposition"];

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (fileNameMatch && fileNameMatch.length === 2) {
          fileName = fileNameMatch[1];
        }
      }

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      if (Capacitor.isNativePlatform()) {
        const reader = new FileReader();

        const blobToBase64 = (blob: Blob) =>
          new Promise((resolve, reject) => {
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });

        try {
          const result: any = await blobToBase64(blob);
          const base64Data = result?.split(",")[1];

          const uniqueFileName = `${Date.now()}_${fileName}`;

          const savedFile = await Filesystem.writeFile({
            path: uniqueFileName,
            data: base64Data,
            directory: Directory.Cache,
          });

          await Share.share({
            url: savedFile.uri,
          });

          onSuccess?.();
        } catch (err) {
          console.error("Native Share Error:", err);
          onError?.();
        }
      } else {
        // 3. Create a hidden link element to trigger the download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // 4. Set the dynamic filename
        link.setAttribute("download", fileName);

        // 5. Trigger click and cleanup
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(url);

        onSuccess?.();
        message.success("Installation Certificate downloaded successfully!");
      }
    } catch (error: any) {
      console.error("PDF Generation error:", error);
      onError?.();

      // Helper to read the error message from a Blob (since responseType is blob)
      if (error.response && error.response.data instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const errorObj = JSON.parse(reader.result as string);
            message.error(errorObj.message || "Failed to generate PDF");
          } catch (e) {
            message.error("Failed to generate PDF");
          }
        };
        reader.readAsText(error.response.data);
      } else {
        message.error("Failed to generate PDF");
      }
    }
  };
export const GetOrderProductionQualityChecklistAPI =
  ({ order_id }: any, onSuccess?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getOrderProductionQualityChecklist", true);
    axiosInstance
      .get(`/orders/manufacturing/quality-checklists`, {
        params: { order_id },
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          if (onSuccess) onSuccess(result?.data);
          dispatchLoading(
            dispatch,
            "getOrderProductionQualityChecklist",
            false,
          );
        } else {
          elseHandler(dispatch, "getOrderProductionQualityChecklist", result);
          dispatchLoading(
            dispatch,
            "getOrderProductionQualityChecklist",
            false,
          );
        }
      })
      .catch((err) => {
        catchHandler(dispatch, "getOrderProductionQualityChecklist")(err);
        dispatchLoading(dispatch, "getOrderProductionQualityChecklist", false);
      });
  };

export const UpdateOrderProductionQualityChecklistAPI =
  (payload: any, onSuccess?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateOrderProductionQualityChecklist", true);
    axiosInstance
      .put(`/orders/manufacturing/quality-checklists`, payload)
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          if (onSuccess) onSuccess(result?.data);
          dispatchLoading(
            dispatch,
            "updateOrderProductionQualityChecklist",
            false,
          );
        } else {
          elseHandler(
            dispatch,
            "updateOrderProductionQualityChecklist",
            result,
          );
          dispatchLoading(
            dispatch,
            "updateOrderProductionQualityChecklist",
            false,
          );
        }
      })
      .catch((err) => {
        catchHandler(dispatch, "updateOrderProductionQualityChecklist")(err);
        dispatchLoading(
          dispatch,
          "updateOrderProductionQualityChecklist",
          false,
        );
      });
  };

export const GetProductionJobQualityChecklistsAPI =
  ({ job_id }: any, onSuccess?: (data: any) => void) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getProductionJobQualityChecklists", true);
    axiosInstance
      .get(`/orders/manufacturing/production-quality-checklists`, {
        params: { job_id },
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          if (onSuccess) onSuccess(result?.data);
          dispatchLoading(dispatch, "getProductionJobQualityChecklists", false);
        } else {
          elseHandler(dispatch, "getProductionJobQualityChecklists", result);
          dispatchLoading(dispatch, "getProductionJobQualityChecklists", false);
        }
      })
      .catch((err) => {
        catchHandler(dispatch, "getProductionJobQualityChecklists")(err);
        dispatchLoading(dispatch, "getProductionJobQualityChecklists", false);
      });
  };
